import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getCroppedError } from '../../../../utils';
import WarningModal from '../../../../WarningModal';
import { getErrorMessageState } from '../../../store/errorMessage/selectors';
import { clearErrorMessage } from '../../../store/errorMessage/actions';

const ErrorModal: React.FC = () => {
	const { t } = useTranslation('Checkout');

	const dispatch = useDispatch();

	const errorMessage = useSelector(getErrorMessageState);

	const onCloseErrorModal = () => {
		dispatch(clearErrorMessage());
	};

	return (
		<WarningModal
			isOpen={!!errorMessage}
			title={t('Oops...')}
			content={null}
			errorMessage={errorMessage ? getCroppedError(errorMessage) : ''}
			onClose={onCloseErrorModal}
			onButtonClick={onCloseErrorModal}
			buttonText={t('OK, thank you')}
		/>
	);
};

export default ErrorModal;
